import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const SPECIALTIES_ENDPOINTS = {
  V2: createEndpoints('v2', {
    SPECIALIZATIONS: '/engagements/specializations/',
    SPECIALIZATION_BY_ID: (id: number | string) => `/engagements/specializations/${id}/`,
  }),
} as const;
